/* global $, Swal */
import { captchaApiUrl } from './captchaApi';
const submissions = new WeakMap();
export default async function requestCaptcha(vm, purpose) {
  if (submissions.has(vm)) return null;
  const component = vm.$refs.captcha;
  if (!component) return null;
  const answer = component.take(purpose);
  if (!answer) {
    Swal.close();
    component.$el.scrollIntoView({ block: 'center', behavior: 'smooth' });
    return null;
  }
  submissions.set(vm, component);
  return answer;
}
export function captchaAjax(vm, captcha, options) {
  const component = submissions.get(vm);
  return $.ajax({ ...options, url: captchaApiUrl(options.url), timeout: options.timeout || 60000,
    // Issuing and consuming a challenge must use the same ASP.NET Session.
    xhrFields: { ...options.xhrFields, withCredentials: true },
    data: { ...options.data, ...captcha },
    error(...args) {
      if (options.error) options.error(...args);
      Swal.fire({ icon: 'error', text: '連線失敗，請確認操作結果後重試。 / Connection failed. Check the result before retrying.' });
    },
    complete(...args) {
      submissions.delete(vm);
      vm.$nextTick(() => {
        if (component && !component._isDestroyed) component.release();
      });
      if (options.complete) options.complete(...args);
    }
  });
}
